// Page publique /verify-identity/:token — « Oui c'est bien moi ».
// Clés préfixées "verify." — voir i18n/index.js pour la convention.
const verify = {
  fr: {
    "verify.secure_badge": "Vérification sécurisée",
    "verify.err_invalid": "Lien invalide.",
    "verify.err_not_found": "Lien introuvable ou expiré.",
    "verify.err_confirm": "Impossible de confirmer pour le moment.",
    "verify.expired_title": "Lien expiré",
    "verify.expired_body":
      "Ce lien de vérification n'est plus valide. Retournez sur la page de don pour en demander un nouveau.",
    "verify.back_home": "Retour à l'accueil",
    "verify.invalid_title": "Lien invalide",
    "verify.confirmed_title": "Identité confirmée",
    "verify.thanks": "Merci.",
    "verify.thanks_named": "Merci, {name}.",
    "verify.confirmed_before": "Vous pouvez maintenant",
    "verify.confirmed_strong": "retourner sur la page de don",
    "verify.confirmed_after":
      "qui est restée ouverte — la suite s'est débloquée automatiquement.",
    "verify.org_label": "Organisation : {org}",
    "verify.confirm_title": "Confirmer mon identité",
    "verify.intro":
      "Quelqu'un (vous, j'espère !) souhaite faire un don ou réserver via cette adresse. Confirmez en un clic pour débloquer votre page de don.",
    "verify.cta": "Oui, c'est bien moi",
    "verify.footnote":
      "Si ce n'est pas vous, ignorez simplement cette page. Aucune action ne sera entreprise sans votre confirmation.",
  },
  en: {
    "verify.secure_badge": "Secure verification",
    "verify.err_invalid": "Invalid link.",
    "verify.err_not_found": "Link not found or expired.",
    "verify.err_confirm": "We couldn't confirm right now. Please try again.",
    "verify.expired_title": "Link expired",
    "verify.expired_body":
      "This verification link is no longer valid. Please return to the donation page to request a new one.",
    "verify.back_home": "Back to home",
    "verify.invalid_title": "Invalid link",
    "verify.confirmed_title": "Identity confirmed",
    "verify.thanks": "Thank you.",
    "verify.thanks_named": "Thank you, {name}.",
    "verify.confirmed_before": "You can now",
    "verify.confirmed_strong": "return to the donation page",
    "verify.confirmed_after":
      "you left open — the next step has unlocked automatically.",
    "verify.org_label": "Organization: {org}",
    "verify.confirm_title": "Confirm my identity",
    "verify.intro":
      "Someone (hopefully you!) wants to make a donation or a reservation using this address. Confirm with one click to unlock your donation page.",
    "verify.cta": "Yes, it's me",
    "verify.footnote":
      "If this wasn't you, simply ignore this page. No action will be taken without your confirmation.",
  },
};

export default verify;
